import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "position-relative" };
const _hoisted_2 = {
    key: 1,
    class: "container-sm"
};
const _hoisted_3 = { class: "col-md-12" };
const _hoisted_4 = {
    class: "row category-list",
    style: { "overflow-y": "auto" }
};
const _hoisted_5 = ["category"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_category_card = _resolveComponent("g-category-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
            : _createCommentVNode("", true),
        ((_ctx.category?.products?.length ?? 0) === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.categories, (category, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: category.id,
                                category: category,
                                class: "col-md-6 col-xl-4"
                            }, [
                                _createVNode(_component_g_category_card, { category: category }, null, 8, ["category"])
                            ], 8, _hoisted_5));
                        }), 128))
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
